module.exports = __webpack_public_path__ + "static/media/Quotes.3dceed11.svg";